import { render } from "./ExibText.vue?vue&type=template&id=2ed82150&scoped=true"
import script from "./ExibText.vue?vue&type=script&lang=js"
export * from "./ExibText.vue?vue&type=script&lang=js"

import "./ExibText.vue?vue&type=style&index=0&id=2ed82150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed82150"]])

export default __exports__